import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { AppState } from "./state";

const defaultState: AppState = {
  error: null,
  errorTimeout: 5000,
  hasUnsavedChanges: false
};

export const appStateModule = {
  state: defaultState,
  mutations,
  actions,
  getters
};
